
import { types, actions } from './requests'
export const CREATELABEL_TYPES = {
    ...types('CREATELABEL'),
}
export const CREATELABEL_ACTIONS = {
    ...actions('CREATELABEL'),
}